import { useMemo } from "react";
import { addRupeeCharToFormattedAmount } from "services";

export interface PropertyDataType {
  propertyData: any;
}

export function usePrivatePDAuctionDetails({ propertyData }: PropertyDataType) {
  const auctionDetails = useMemo(() => {
    const balcony = propertyData?.posted_properties_raw_data?.noOfBalcony?.value
      ? propertyData?.posted_properties_raw_data?.noOfBalcony?.value === "1"
        ? `${propertyData?.posted_properties_raw_data?.noOfBalcony?.value} Balcony`
        : `${propertyData?.posted_properties_raw_data?.noOfBalcony?.value} Balconies`
      : "";

    const bathroom = propertyData?.posted_properties_raw_data?.noOfBathroom
      ?.value
      ? propertyData?.posted_properties_raw_data?.noOfBathroom?.value === "1"
        ? `${propertyData?.posted_properties_raw_data?.noOfBathroom?.value} Bathroom`
        : `${propertyData?.posted_properties_raw_data?.noOfBathroom?.value} Bathrooms`
      : "";

    const parking = propertyData?.posted_properties_raw_data?.noOfParking?.value
      ? propertyData?.posted_properties_raw_data?.noOfParking?.value === "1"
        ? `${propertyData?.posted_properties_raw_data?.noOfParking?.value} Parking`
        : `${propertyData?.posted_properties_raw_data?.noOfParking?.value} Parkings`
      : "";

    const propertyAge =
      propertyData?.posted_properties_raw_data?.ageOfPropertyAdv;
    const totalFloors = propertyData?.posted_properties_raw_data?.totalFloorAdv;

    const result = [bathroom, parking, balcony].filter(Boolean).join(", ");
    propertyData["totalFloors"] = totalFloors;
    propertyData["configuration"] = result;
    propertyData["ageOfProperty"] = propertyAge;

    let options = [
      {
        label: "Base Price",
        value: `${addRupeeCharToFormattedAmount(propertyData?.reserve_price)} ${
          propertyData?.area
            ? `@${(propertyData?.reserve_price / propertyData?.area)?.toFixed(
                2,
              )} PER SQ FT`
            : ""
        }`,
      },
      {
        label: "Property Age",
        value: propertyData?.ageOfProperty
          ? `${propertyData?.ageOfProperty} year old`
          : "N/A",
      },
      {
        label: "Total Floors",
        value: propertyData?.totalFloors
          ? `${propertyData?.totalFloors} floors`
          : "N/A",
      },
      {
        label: "Project Amentities",
        value:
          propertyData?.sub_asset_type?.slug !== "flat" &&
          propertyData?.posted_properties_raw_data?.societyAmentities
            ? propertyData?.posted_properties_raw_data?.societyAmentities
                ?.map((item: any) => item?.title)
                ?.join(", ")
            : "N/A",
      },
      {
        label: "Furnishings Details",
        value:
          propertyData?.posted_properties_raw_data?.flatFurnishing &&
          (propertyData?.sub_asset_type?.slug === "individual-house" ||
            propertyData?.sub_asset_type?.slug === "flat")
            ? propertyData?.posted_properties_raw_data?.flatFurnishing
                ?.map((item: any) => item?.title)
                ?.join(", ")
            : "N/A",
      },
      {
        label: "Configuration",
        value: propertyData?.configuration
          ? `${propertyData?.configuration}`
          : "N/A",
      },
    ];
    return options;
  }, [propertyData]);

  return { auctionDetails };
}
